import { beforeEnterHasPerm } from '@/components/PermissionHelper'

const beforeEnter = (to, from, next) => { return beforeEnterHasPerm(to, from, next) }

const ROUTES = {
  PHONE_TYPOLOGY_LIST: 'organization-phone-typology'
}

const routes = [
  {
    path: 'phone-typology/',
    name: ROUTES.PHONE_TYPOLOGY_LIST,
    beforeEnter: beforeEnter,
    meta: {
      permissions: ['organization_phonetypology_list'],
      requiresAuth: true
    },
    component: () => import('./PhoneTypologyList.vue')
  }

]

export { routes, ROUTES }
